
export default function PartnersSection() {
  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="container px-4">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 lg:mb-4">
            Nossos <span className="gradient-text-orange">Parceiros</span>
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Certificados e reconhecidos pelas principais plataformas digitais do mundo
          </p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-12 items-center justify-center">
          {/* Google Partner */}
          <div className="group cursor-pointer transition-all duration-300 hover:scale-105">
            <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
              <img 
                src="https://static.readdy.ai/image/60d079db6e314477a5615b4d3efd8435/c8d1ce2a6d0b833fdad68953cb4b0387.png"
                alt="Google Partner"
                className="h-12 lg:h-16 w-auto mx-auto"
              />
            </div>
            <div className="text-center mt-3 lg:mt-4">
              <h3 className="text-base lg:text-lg font-semibold text-gray-900">Google Partner</h3>
              <p className="text-xs lg:text-sm text-gray-600">Certificação em Google Ads</p>
            </div>
          </div>
          
          {/* Meta Partner */}
          <div className="group cursor-pointer transition-all duration-300 hover:scale-105">
            <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
              <img 
                src="https://static.readdy.ai/image/60d079db6e314477a5615b4d3efd8435/474703d58d0ddeb1f3bb41dae5f4c506.png"
                alt="Meta Partner"
                className="h-12 lg:h-16 w-auto mx-auto"
              />
            </div>
            <div className="text-center mt-3 lg:mt-4">
              <h3 className="text-base lg:text-lg font-semibold text-gray-900">Meta Partner</h3>
              <p className="text-xs lg:text-sm text-gray-600">Especialistas em Facebook e Instagram</p>
            </div>
          </div>
          
          {/* LinkedIn Partner */}
          <div className="group cursor-pointer transition-all duration-300 hover:scale-105">
            <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
              <img 
                src="https://static.readdy.ai/image/60d079db6e314477a5615b4d3efd8435/45ca83f6be657dd0bd2c2f02ca7a65d3.jpeg"
                alt="LinkedIn Partner"
                className="h-12 lg:h-16 w-auto mx-auto"
              />
            </div>
            <div className="text-center mt-3 lg:mt-4">
              <h3 className="text-base lg:text-lg font-semibold text-gray-900">LinkedIn Partner</h3>
              <p className="text-xs lg:text-sm text-gray-600">Marketing B2B Profissional</p>
            </div>
          </div>
          
          {/* Lovoo CRM */}
          <div className="group cursor-pointer transition-all duration-300 hover:scale-105">
            <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
              <img 
                src="/images/logo_fundo_branco-300x128.png"
                alt="Lovoo CRM"
                className="h-12 lg:h-16 w-auto mx-auto"
              />
            </div>
            <div className="text-center mt-3 lg:mt-4">
              <h3 className="text-base lg:text-lg font-semibold text-gray-900">Lovoo CRM</h3>
              <p className="text-xs lg:text-sm text-gray-600">CRM, Automação Avançada e IA</p>
            </div>
          </div>
        </div>
        
        {/* Trust Indicators */}
        <div className="mt-12 lg:mt-16 text-center">
          <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-700 px-4 lg:px-6 py-2 lg:py-3 rounded-full border border-orange-200">
            <i className="ri-shield-check-line text-base lg:text-lg"></i>
            <span className="font-medium text-sm lg:text-base">Certificações Oficiais Verificadas</span>
          </div>
        </div>
      </div>
    </section>
  );
}
